export default __webpack_public_path__ + "static/media/linkedin_rounded.93fae6f3.svg";